import { Tag } from 'antd';

export const PAGINATION_DEFAULT = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
};

export const DEBOUNCE_TIMES = {
  NAME: 300,
  SLUG: 300,
};

export const TABLE_COLUMNS = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: "5%",
    align: "center",
    render: (text, record, index) => {
      const { current, pageSize } = record.pagination || {};
      if (current && pageSize) {
        return (current - 1) * pageSize + index + 1;
      }
      return index + 1;
    },
  },
  {
    title: "URL-friendly",
    dataIndex: "slug",
    key: "slug",
    width: "25%",
    render: (text) => (
      <span>
        {text}
      </span>
    )
  },
  {
    title: "Course Name",
    dataIndex: "name",
    key: "name",
    width: "20%",
  },
  {
    title: "Author",
    dataIndex: "author",
    key: "author",
  },
  {
    title: "Category",
    dataIndex: ["category", "name"],
    key: "category",
    render: (_, record) => record.category?.name || "",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    render: (price) => `$${price?.toFixed(2)}`,
  },
  {
    title: "Status",
    dataIndex: "isActive",
    key: "isActive",
    render: (isActive) => (
      <Tag color={isActive ? "success" : "error"}>
        {isActive ? "Active" : "Inactive"}
      </Tag>
    ),
  },
];
